import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Row, Col, Input, Select, Spin, Tooltip } from "antd";
import { Button, Toggle } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomChip from "../general/chips";
import "./edit.css";
import DocumentBrowsing from "../general/DocumentBrowsing";
import { FormattedMessage } from "react-intl";
import { getDocumentType } from "../../store/actions/documents/classification";
import { displayWarningToast } from "../../store/actions/overflowNotification";
import { categoryToDesc } from "../../constants/folders";
import { clearFolderDetail } from "../../store/actions/folders/detail";
import ImgFolderFeedback from "../../assets/img/folder-created.svg";
import Uploader from "../uploader";
import * as uploadActions from "../../store/actions/documents/upload";
import {
  createFoldersWithUpload,
  updateFoldersWithUpload
} from "../../store/actions/folders";

const Option = Select.Option;

class FoldersEditPage extends React.PureComponent {
  constructor(props) {    
    super(props);
    this.documentsHandler = this.documentsHandler.bind(this);
    let idByUrl = props.location.pathname.split("folders-edit/")[1];
    if (idByUrl) {
      this.getDetails(idByUrl);
    }
    this.state = {
      modifica: false,
      company: props.clientIdSelected,
      type: "dossier_1",
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      category: categoryToDesc["custom"],
      categoryKey: "custom",
      isChangedYear: false,
      isChangedAttachments: false,
      isChangedCategory: false,
      isChangedAvailableTo: false,
      title: null,
      searchValue: null,
      documents: {},
      searchDialog: false,
      browsingVisible: false,
      modalZoom: false,
      documentBrowsingPage: 1,
      documentBrowsingCategory: "",
      uploadedDocuments: [],
      availableTo: "managed"
    };
  }

  componentWillUnmount() {
    const { clearFolderDetail } = this.props;
    this.setState({
      title: null,
      year: new Date().getFullYear(),
      documents: {}
    });
    clearFolderDetail();
    document.removeEventListener("click", this.setTooltipVisible);
  }

  setTooltipVisible(e){
    if (e.target.id === "Fascicoli-nuovo-addDocument") {
      this.toggleTooltipVisible(true);
    }
  }

  componentDidMount() {
    const { getDocumentType, documents, clearFolderDetail } = this.props;
    if (!this.props.isEditing) {
      clearFolderDetail();
      this.setState({
        title: null,
        year: new Date().getFullYear(),
        documents: {}
      });
    }
    document.addEventListener("click", this.setTooltipVisible);
    if (documents && documents.classification !== undefined) {
      if (documents.classification.typesDocuments.types === null) {
        getDocumentType();
      }
    } else {
      getDocumentType();
    }
  }

  componentDidUpdate(){
    if (this.props.result){
      document.getElementById("dbx-main-container").scrollTop = 0;
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let folderTitle =
      !nextProps.isGettingFolderDetail &&
      nextProps.foldersDetail.subjective &&
      nextProps.foldersDetail.subjective._embedded
        ? nextProps.foldersDetail.subjective._embedded.folderName
        : "";
    let folderYear = prevState.isChangedYear
      ? prevState.year
      : new Date().getFullYear();
    let folderCategory = prevState.isChangedCategory
      ? prevState.categoryKey
      : "custom";
    let folderAvailableTo =
      !prevState.isChangedAvailableTo &&
      !nextProps.isGettingFolderDetail &&
      nextProps.foldersDetail.subjective &&
      nextProps.foldersDetail.subjective._embedded
        ? nextProps.foldersDetail.subjective._embedded.availableTo
        : prevState.availableTo;
    if (
      !nextProps.isGettingFolderDetail &&
      nextProps.foldersDetail.subjective &&
      nextProps.foldersDetail.subjective._embedded &&
      !prevState.isChangedYear
    ) {
      folderYear = nextProps.foldersDetail.subjective._embedded
        ? nextProps.foldersDetail.subjective._embedded.refYear
        : new Date().getFullYear();
    }
    if (
      !nextProps.isGettingFolderDetail &&
      nextProps.foldersDetail.subjective &&
      nextProps.foldersDetail.subjective._embedded &&
      !prevState.isChangedCategory
    ) {
      folderCategory = nextProps.foldersDetail.subjective._embedded
        ? // Nei vecchi fascicoli folderCategory non c'è quindi devo visualizzare Personalizzato per evitare che il campo sia vuoto
      // e fare in modo che l'utente non si accorga che non si tratta più del campo type ma category
        nextProps.foldersDetail.subjective._embedded.folderCategory
          ? nextProps.foldersDetail.subjective._embedded.folderCategory
          : "custom"
        : "custom";
    }
    if (
      !nextProps.isGettingSubjectiveFolderDetailContent &&
      nextProps.foldersDetail.subjective &&
      nextProps.foldersDetail.subjective.attachments
    ) {
      const folderDocuments =
        nextProps.foldersDetail.subjective.attachments._embedded.documents;
      let newDocuments = {};
      folderDocuments.map(item => {
        return (newDocuments[item.id] = {
          documentId: item.id,
          filename: item.fileName
        });
      });
      newDocuments =
        JSON.stringify(prevState.documents) !== JSON.stringify({}) ||
        prevState.isChangedAttachments
          ? prevState.documents
          : newDocuments;
      return {
        documents: newDocuments,
        title: folderTitle,
        year: folderYear || new Date().getFullYear(),
        categoryKey: folderCategory,
        category: categoryToDesc[folderCategory],
        availableTo: folderAvailableTo
      };
    } else if (
      !nextProps.isGettingFolderDetail &&
      nextProps.foldersDetail.subjective
    ) {
      return {
        title: folderTitle,
        year: folderYear || new Date().getFullYear(),
        categoryKey: folderCategory,
        category: categoryToDesc[folderCategory],
        availableTo: folderAvailableTo
      };
    }
    return prevState;
  }

  documentsHandler(uploadedDocuments) {
    this.setState(() => {
      return { uploadedDocuments: [...uploadedDocuments] };
    });
  }

  getDetails(idByUrl) {
    this.props.getFolderById(idByUrl);
    this.props.getFolderDocuments(idByUrl);
  }

  onSaveClick() {
    const {
      displayWarningToast,
      auth,
      user,
      myType,
      accountantIdSelected,
      clientIdSelected,
      company,
      createFoldersWithUpload,
      onSave,
      updateFoldersWithUpload,
      onUpdate,
      location,
      intl
    } = this.props;    
    const { uploadedDocuments } = this.state;
    let docs = [];
    let folderId = location.pathname.split("folders-edit/")[1];
    for (let item in this.state.documents) {
      docs.push(item);
    }
    if (
      !this.state.type ||
      !this.state.title ||
      this.state.title.trim() === "" ||
      !this.state.company ||
      (Object.entries(this.state.documents).length === 0 &&
        Object.entries(this.state.uploadedDocuments).length === 0 &&
        this.state.documents.constructor === Object)
    ) {
      displayWarningToast(intl.formatMessage({id: "folders.toast.noEmptyFields"}), intl.formatMessage({id: "folders.toast.warning"}));
    }
    let requestBody = {
      templateId: this.state.type,
      folderName: this.state.title,
      folderCategory: this.state.categoryKey,
      itemId: this.state.company,
      managerId: accountantIdSelected,
      refYear: "" + this.state.year,
      availableTo: this.state.availableTo,
      queryParams: {
        documentIds: docs
      }
    };
    if (this.props.isEditing) {
      if (Object.entries(this.state.uploadedDocuments).length === 0) {
        onUpdate(folderId, requestBody);
      } else {
        updateFoldersWithUpload(
          auth,
          user,
          uploadedDocuments,
          myType,
          company,
          clientIdSelected,
          accountantIdSelected,
          requestBody,
          docs,
          onUpdate,
          folderId
        );
      }
    } else {
      if (Object.entries(this.state.uploadedDocuments).length === 0) {
        onSave(requestBody);
      } else {
        createFoldersWithUpload(
          auth,
          user,
          uploadedDocuments,
          myType,
          company,
          clientIdSelected,
          accountantIdSelected,
          requestBody,
          docs,
          onSave,
          this.state.availableTo === "owner"
        );
      }
    }
  }

  renderContentForm() {
    const { isEditing } = this.props;
    return (
      <Row span={24}>
        <Col span={6} className="Fascicoli-nuovo-col"></Col>
        <Col span={12} className="Fascicoli-nuovo-col">
          <div>
            {!isEditing ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "47px",
                  fontSize: "14px",
                  height: "40px",
                  lineHeight: "20px",
                  letterSpacing: "0.47px"
                }}
              >
                <span>
                  <span><FormattedMessage id="folders.pages.create.title" /></span>
                  <span style={{ marginLeft: "5px" }}>
                    <b>{this.props.selectedCompanyName.ragioneSociale}</b>
                  </span>
                  <span>
                    <FormattedMessage id="folders.pages.create.required" />{" "}
                  </span>
                </span>
              </div>
            ) : null}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "25px"
              }}
            >
              {this.renderFascicoloTitle()}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginTop: "25px"
              }}
            >
              <Toggle
                checked={this.state.availableTo === "owner"}
                onChange={() =>
                  this.setState({
                    isChangedAvailableTo: true,
                    availableTo:
                      this.state.availableTo === "managed" ? "owner" : "managed"
                  })
                }
              />{" "}
              <span className="dbx-folders-availableTo-label">
                {" "}
                <FormattedMessage id="folders.onlyStudio" />
              </span>{" "}
              <span className="dbx-folders-availableTo-icon">
                <Tooltip title={<FormattedMessage id="folders.onlyStudioTooltip" />}
                  color={"rgb(0, 80, 117)"}
                >
                  <FontAwesomeIcon icon={["far", "info-circle"]} />
                </Tooltip>
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "25px" // ,
                //  width: "655px"
              }}
            >
              {this.renderFascicoloCategoria()}
              {this.renderFascicoloPeriodo()}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "25px"
              }}
            >
              {this.renderFascicoloRicercaDocumento()}
            </div>
          </div>
        </Col>
        <Col span={6} className="Fascicoli-nuovo-col"></Col>
      </Row>
    );
  }

  renderFascicoloTitle() {
    const { user, isEditing } = this.props;
    return (
      <div style={{ flex: "1 1 auto", width: "50%" }}>
        <div className="labelDialogFolder">
          <FormattedMessage id="folders.pages.edit.labels.name" /> {"*"}
        </div>
        <div className="inputFascicoliCustom">
          <Input
            maxLength={30}
            disabled={isEditing && true}
            onChange={e =>
              !isEditing && this.setState({ title: e.target.value })
            }
            placeholder={user?.profile?.language === "es-ES" ? "Introduce el nombre del expediente" : "Inserisci il nome del fascicolo"}
            value={this.state.title}
            suffix={!isEditing && <FontAwesomeIcon icon={["far", "pencil"]} />}
          />
        </div>
      </div>
    );
  }

  renderFascicoloSelezionaDocumento() {
    return (
      <div style={{ flex: "1 1 auto", marginRight: "32px", width: "50%" }}>
        <div className="labelDialogFolder">Documenti da includere</div>
        <div className="customFascicoliSelect largeFascicoliSelect">
          <Select size="large" mode="multiple">
            <Option value={1}>Dichiarazione dei redditi</Option>
            <Option value={2}>Atto notarile costituzione società</Option>
            <Option value={3}>Text label</Option>
            <Option value={4}>Bilancio xbrl</Option>
          </Select>
        </div>
      </div>
    );
  }

  addSelectedDocument(document) {
    let newdocs = this.state.documents;
    if (!newdocs[document.documentId]) {
      newdocs[document.documentId] = document;
    }
    this.setState({ documents: newdocs, isChangedAttachments: true });
    this.forceUpdate();
  }

  loadDocumentsByCategory(
    category, link, focus
  ) {
    const {
      getDocumentsWithSearch
    } = this.props;
    this.setState({ documentBrowsingCategory: category });

    getDocumentsWithSearch(
      link,
      "",
      false,
      { category: category }
    );
    if (focus) {
      document.getElementById("folders-edit-browsing_input").focus();
    }
  }

  previewDocument(docId) {
    const {
      loadFolderDocument,
      loadFolderDocumentPreview
    } = this.props;
    loadFolderDocumentPreview(docId);
    loadFolderDocument(docId);
    this.setState({
      modalZoom: true,
      modalZoomDocId: docId
    });
  }

  addPageModalZoom() {
    const {
      isLoadingPreview,
      loadFolderDocumentPreview
    } = this.props;
    if (!this.state.docId || isLoadingPreview) {
      return null;
    }
    loadFolderDocumentPreview(this.state.docId,
      this.state.modalZoomPage + 1);
    this.setState({ modalZoomPage: this.state.modalZoomPage + 1 });
    return undefined;
  }

  toggleTooltipVisible(visible) {
    this.setState({ browsingVisible: visible });
  }

  resetDocuments() {

    this.props.getDocumentsWithSearch(null,
      "");
  }

  renderFascicoloRicercaDocumento() {
    const {
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      auth,
      company,
      documents,
      currentPermissions: { permissionUser },      
      resetUploadDocument,
      uploadDocuments,
      user,
      myType
    } = this.props;
    return (
      <div className="folders-edit-document-upload-container">
        <DocumentBrowsing
          accountantSelected={accountantSelected}
          accountantIdSelected={accountantIdSelected}
          companySelected={companySelected}
          clientIdSelected={clientIdSelected}
          selected={this.state.documents}
          addDocument={this.addSelectedDocument.bind(this)}
          fullWidth={true}
          isFoldersEdit={true}
          id="folders-edit-browsing"
        />
        <div className="folders-edit-document-upload-chips-container">
          {this.renderRiepilogoDocumenti()}
        </div>
        <div className="folders-edit-document-upload-divider">
          <FormattedMessage id="generalText.orText" />{" "}
        </div>
        <Uploader
          accountantSelected={accountantSelected}
          accountantIdSelected={accountantIdSelected}
          auth={auth}
          company={company}
          companySelected={companySelected}
          clientIdSelected={clientIdSelected}
          currentPermissions={permissionUser}
          documents={documents}          
          resetUploadDocument={resetUploadDocument.bind(this)}
          uploadDocuments={uploadDocuments}
          user={user}
          myType={myType}
          isFoldersEdit={true}
          uploadDocAction={this.documentsHandler}
        />
      </div>
    );
  }

  renderYears() {
    let years = [];
    for (let x = -5; x < 10; x++) {
      years.push(<Option
        key={`year_${new Date().getFullYear() + x}`}
        value={new Date().getFullYear() + x}
      >
        {(new Date().getFullYear() + x).toString()}
      </Option>);
    }
    return years;
  }

  renderCategory() {
    let categories = [];
    for (let cat in categoryToDesc) {
      categories.push(<Option key={"categoria_" + cat} value={cat}>
        <FormattedMessage id={"folders.typology." + categoryToDesc[cat]} defaultMessage={categoryToDesc[cat]} />
      </Option>);
    }
    return categories;
  }

  renderFascicoloPeriodo() {
    return (
      <div style={{ flex: "1 1 30%", width: "100%" }}>
        <div style={{ flex: "1 1 auto", width: "100%" }}>
          <div className="labelDialogFolder">
            <FormattedMessage id="folders.pages.edit.labels.period" /> {"*"}
          </div>
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "100%" }}>
            <div className="customFascicoliSelect largeFascicoliSelect">
              <Select
                size="large"
                value={this.state.year}
                style={{ width: "100%" }}
                onChange={value =>
                  this.setState({ year: value, isChangedYear: true })
                }
              >
                {this.renderYears()}
              </Select>
            </div>
          </div>
          <div style={{ display: "none", marginLeft: 20 }}>
            <div className="labelDialogFolder">Mese</div>
            <div className="customFascicoliSelect largeFascicoliSelect">
              <Select
                size="large"
                value={this.state.month}
                style={{ width: "150px" }}
              >
                <Option value={1}>Gennaio</Option>
                <Option value={2}>Febbraio</Option>
                <Option value={3}>Marzo</Option>
                <Option value={4}>Aprile</Option>
                <Option value={5}>Maggio</Option>
                <Option value={6}>Giugno</Option>
                <Option value={7}>Luglio</Option>
                <Option value={8}>Agosto</Option>
                <Option value={9}>Settembre</Option>
                <Option value={10}>Ottobre</Option>
                <Option value={11}>Novembre</Option>
                <Option value={12}>Dicembre</Option>
              </Select>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderFascicoloCategoria() {
    const {intl} = this.props;
    return (
      <div style={{ flex: "1 1 70%", marginRight: "32px", width: "95%" }}>
        <div style={{ flex: "1 1 auto", marginRight: "32px", width: "100%" }}>
          <div className="labelDialogFolder">
            <FormattedMessage id="folders.pages.edit.labels.type" /> {"*"}
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <div className="customFascicoliSelect largeFascicoliSelect">
            <Select
              size="large"
              value={intl.formatMessage({id: "folders.typology." + this.state.category, defaultMessage: this.state.category})}
              style={{ width: "100%" }}
              onChange={value =>
                this.setState({
                  category:  intl.formatMessage({id:"folders.typology." + categoryToDesc[value]}),
                  categoryKey: value,
                  isChangedCategory: true
                })
              }
            >
              {this.renderCategory()}
            </Select>
          </div>
        </div>
      </div>
    );
  }

  renderFascicoloObbligatorio() {}

  renderFascicoloAziende() {
    return (
      <div style={{ flex: "1 1 auto", marginRight: "32px", width: "50%" }}>
        <div className="labelDialogFolder">Seleziona Azienda</div>
        <div className="customFascicoliSelect largeFascicoliSelect">
          <Select
            disabled
            size="large"
            value={this.state.company}
            onChange={value => this.setState({ company: value })}
          >
            {this.renderAziende()}
          </Select>
        </div>
      </div>
    );
  }

  renderAziende() {
    let aziende = [];
    if (this.props.company) {
      this.props.company.companies.map(item => {
        if (!item.accountant) {
          aziende.push(<Option key={item.id} value={item.codiceFiscale}>
            {item.ragioneSociale}
          </Option>);
        }
        return null;
      });
    }
    return aziende;
  }

  renderRiepilogoDocumenti() {
    let chips = [];
    const { documents } = this.state;
    let documentsToCheck = documents;
    for (let item in documentsToCheck) {
      chips.push(<CustomChip
        key={`riepilogoDoc_${documentsToCheck[item].documentId}`}
        closable={true}
        onClose={() => this.removeDocument(documentsToCheck[item].documentId)}
        style={{ marginTop: "10px" }}
        description={documentsToCheck[item].filename}
      />);
    }
    return chips;
  }

  removeDocument(documentId) {
    let newdocs = {};
    newdocs = this.state.documents;
    delete newdocs[documentId];
    this.setState({ documents: newdocs, isChangedAttachments: true });
    this.forceUpdate();
  }

  render() {
    const { isEditing, result, title, documents, navigate } = this.props;    
    if (result) {
      return (
        <div>
          <div className={"folderEdit-root"}>
            <div className="folderEdit-result-img">
              <img src={ImgFolderFeedback} alt="" />
              <div>
                <FormattedMessage id="folders.folder" />{" "}
                <strong>{title}</strong>{" "}
                {!isEditing ? (
                  <FormattedMessage id="folders.created" />
                ) : (
                  <FormattedMessage id="folders.edited" />
                )}
              </div>
            </div>
            <div className="folderEdit-result-button">
              <Button onClick={() => navigate("/folders")} kind="secondary">
                <FormattedMessage id="folders.allfolders" />
              </Button>
            </div>
          </div>
        </div>
      );
    }
    
    const loader = (
      <Spin
        indicator={<FontAwesomeIcon icon={["far", "circle-notch"]} spin />}
        size="large"
        tip={
          <span>
            <FormattedMessage id="folders.loading" />
          </span>
        }
        style={{ fontSize: "20px" }}
      />
    );
    return (
      <div>
        <div className="Fascicoli-nuovo-spinner">
          {this.props.folders.isSavingFolders ? (
            <Spin
              indicator={
                <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
              }
              size="large"
              tip={
                <span>
                  <FormattedMessage id="folders.saving" />
                </span>
              }
              style={{ fontSize: "20px" }}
            />
          ) : null}
        </div>
        <div className="Fascicoli-nuovo-root">
          {!isEditing ||
          (isEditing &&
            !this.props.folders.isGettingFolderDetail &&
            this.props.foldersDetail.subjective) ? (
              this.renderContentForm()
            ) : (
              <div
                style={{ width: "100%", textAlign: "center", paddingTop: 200 }}
              >
                {loader}
              </div>
            )}
        </div>
        {((!isEditing && !this.props.folders.isSavingFolders) ||
          (isEditing &&
            !this.props.folders.isGettingFolderDetail &&
            this.props.foldersDetail.subjective &&
            !this.props.folders.isSavingFolders)) && (
          <div className="Fascicoli-nuovo-bottomBar">
            <Button
              kind="tertiary"
              size="small"
              onClick={() => navigate("/folders")}
            >
              <FormattedMessage id="actions.cancel" />
            </Button>
            <Button
              className={
                this.props.isEditing
                  ? "gs-folders-save btn-folder-update"
                  : "gs-folders-save btn-folder-create"
              }
              size="small"
              onClick={this.onSaveClick.bind(this, documents)}
            >
              {this.props.isEditing ? (
                <FormattedMessage id="folders.pages.edit.actions.update" />
              ) : (
                <FormattedMessage id="folders.pages.edit.actions.create" />
              )}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    documents: state.documents,
    company: state.company,
    currentPermissions: state.currentPermissions,
    user: state.user,
    myType: state.main.myType,
    main: state.main,
    studio: state.studio,
    clientIdSelected: state.main.clientIdSelected,
    accountantIdSelected: state.main.accountantIdSelected
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDocumentType: bindActionCreators(getDocumentType, dispatch),
    clearFolderDetail: bindActionCreators(clearFolderDetail, dispatch),
    displayWarningToast: bindActionCreators(displayWarningToast, dispatch),
    uploadDocuments: bindActionCreators(uploadActions.uploadDocuments,
      dispatch),
    resetUploadDocument: bindActionCreators(uploadActions.resetUploadDocument,
      dispatch),
    createFoldersWithUpload: bindActionCreators(createFoldersWithUpload,
      dispatch),
    updateFoldersWithUpload: bindActionCreators(updateFoldersWithUpload,
      dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FoldersEditPage);
